module.exports = __webpack_public_path__ + "static/media/sign-in-alt.5034582d.svg";